module.exports = __webpack_public_path__ + "img/logo_afterbanks_web.min.923412cd.svg";